module.exports = __webpack_public_path__ + "static/media/Tetech.fa298fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Tetech.png
// module id = 476
// module chunks = 0